import type { Theme } from '@mui/material';
import { alpha } from '@mui/material';

export const styles = {
  bubbleWidget: {
    width: '100%',
    position: 'relative',
    padding: 2,
  },

  missingComparison: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.common.white, 0.9),
    position: 'absolute',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: -8,
    color: theme.palette.primary.main,
    fontSize: `${theme.typography.body2.fontSize}`,
    fontWeight: 'bold',
    zIndex: 1,
  }),

  headline: (theme: Theme) => ({
    fontSize: theme.typography.h2.fontSize,
    fontWeight: 'bold',
  }),

  wrapper: (theme: Theme) => ({
    // The styles are required for resizing the Bubble chart.
    // https://www.chartjs.org/docs/latest/configuration/responsive.html.
    p: 2,
    position: 'relative',
    height: '70vh',

    [theme.breakpoints.up('sm')]: {
      height: '50vh',
    },

    [theme.breakpoints.up('lg')]: {
      height: '40vh',
    },
  }),

  advantageLabel: (theme: Theme) => ({
    position: 'absolute',
    color: theme.colors.generalVeryPositive,
    fontWeight: 'bold',
    right: 0,
    top: -24,
    bottom: null,

    [theme.breakpoints.up('sm')]: {
      bottom: 8,
      top: 'auto',
    },
  }),

  disadvantageLabel: (theme: Theme) => ({
    position: 'absolute',
    color: theme.colors.generalVeryNegative,
    fontWeight: 'bold',
    left: 30,
    bottom: null,
    top: -24,

    [theme.breakpoints.up('sm')]: {
      bottom: 8,
      top: 'auto',
    },
  }),
};
